
import React, { useState } from "react";
import PageHeader from "./PageHeader";

const E_Content = () => {
  const data = [
    {
      subject: "Commerce",
      subSubjects: [
        {
          subject: "Accounting / Finance",
          notes: [
            { title: "Basic Accounting MCQs", link: "https://drive.google.com/file/d/1-TK-xhVtb3l1yF9Kp-G4caT-xESBeThE/view" },
            { title: "Basic Accounting PPT", link: "https://drive.google.com/file/d/10eMEU9kSbKFddXF5vo9HEZUEVgLtEsxc/view" },
            { title: "Basic Accounting PPTX", link: "https://drive.google.com/file/d/1Nai-1UDl9XIO1Ndjbt2yYSsCq_oSEdBh/view" },
            { title: "Computerized Accounting Book Writing", link: "https://drive.google.com/file/d/1N_6lB3isnSE4gxERbYbCwdRccxB49_Qo/view" },
            { title: "Income Tax Summary", link: "https://drive.google.com/file/d/1qy86rA85SEJlY-icstTHHR8TM_IXIhyr/view" },
            { title: "Index Numbers Notes", link: "https://drive.google.com/file/d/1u-yK9LrNxZ5J9jPCQtgbVHMycpVSOzdn/view" }
          ]
        },
        {
          subject: "Business & Management",
          notes: [
            { title: "Business Communication Notes - Dr. Manish", link: "https://drive.google.com/file/d/1o6yLKa8uaWdsXUyN4W_BxS1wShDuJkBM/view" },
            { title: "Business Communication Study Material (Hindi)", link: "https://drive.google.com/file/d/1K4x0FPJne5sbr6g84G2g5aWy7ohcxzVx/view" },
            { title: "Functional Areas of Management", link: "https://drive.google.com/file/d/1sEacrNVDzs3oxiUFQ9-4Wpym5ozTTBPv/view" },
            { title: "Marketing Management", link: "https://drive.google.com/file/d/1Wa-5Q79WwTIegh5P-wFksFQbvGsTe88_/view" },
            { title: "Direct Marketing & Digital Marketing", link: "https://drive.google.com/file/d/1Ml0qlzJ0KodAIzoYPd0EiDkOLn5k56Gv/view" },
            { title: "Organizational Behavior (OB) Notes", link: "https://drive.google.com/file/d/1hJuOfJT4XXVvBxbI6llv-B1UCPjJuk9k/view" },
            { title: "Organizational Behavior", link: "https://drive.google.com/file/d/1Fe4IYJ6NxxDYsBBxVhVl-s8M2TFDEykr/view" },
            { title: "Consumer Behaviour", link: "https://drive.google.com/file/d/1-TK-xhVtb3l1yF9Kp-G4caT-xESBeThE/view" }
          ]
        },
        {
          subject: "Business Law",
          notes: [
            { title: "Company Law Notes", link: "https://drive.google.com/file/d/1OzFKziNNTkoWlfjXrcjKRjsfB0iujQ6o/view" }
          ]
        },
        {
          subject: "Computer Applications",
          notes: [
            { title: "Computer Concepts and Applications", link: "https://drive.google.com/file/d/1L4xL5rCOlF3W_q7A7rlbUw2TcRLgDH9s/view" }
          ]
        },
        {
          subject: "Business Environment",
          notes: [
            { title: "व्यावसायिक पर्यावरण", link: "https://drive.google.com/file/d/1JPhchDJoONLH231-ygnsOM80RUzSe2kM/view" }
          ]
        }
      ]
    }
  ];

  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSubSubject, setSelectedSubSubject] = useState(null);

  const handleSubjectClick = (subject) => {
    setSelectedSubject(subject);
    setSelectedSubSubject(subject.subSubjects[0]); // Automatically select first sub-subject
  };

  const handleBackToMain = () => {
    setSelectedSubject(null);
    setSelectedSubSubject(null);
  };

  return (
    <>
      <PageHeader title="E-Content" />
      <div className="econtent-container">
        {/* Main Subjects Grid - 4 in a row */}
        {!selectedSubject ? (
          <>
            <h1 className="main-title">Select Your Subject</h1>
            <div className="subjects-main-grid">
              {data.map((subject) => (
                <div
                  key={subject.subject}
                  className="main-subject-card"
                  onClick={() => handleSubjectClick(subject)}
                >
                  <div className="subject-icon">
                    {subject.subject === "Commerce" && "📊"}
                    {subject.subject === "Hindi" && "📗"}
                    {subject.subject === "English" && "📘"}
                    {subject.subject === "Science" && "🔬"}
                  </div>
                  <h2>{subject.subject}</h2>
                  <p className="subject-count">{subject.subSubjects.length} Topics</p>
                  <button className="explore-btn">Explore →</button>
                </div>
              ))}
            </div>
          </>
        ) : (
          /* Detail View with Sidebar */
          <div className="detail-layout">
            {/* Back button for mobile */}
            <button className="mobile-back-btn" onClick={handleBackToMain}>
              ← Back to Subjects
            </button>

            {/* Sidebar with all sub-subjects */}
            <div className="subjects-sidebar">
              <div className="sidebar-header">
                <button className="back-btn" onClick={handleBackToMain}>
                  ← Back
                </button>
                <h3>{selectedSubject.subject}</h3>
                <p className="total-topics">{selectedSubject.subSubjects.length} Topics</p>
              </div>

              <div className="sidebar-subjects-list">
                {selectedSubject.subSubjects.map((sub) => (
                  <div
                    key={sub.subject}
                    className={`sidebar-subject-item ${selectedSubSubject?.subject === sub.subject ? "active" : ""}`}
                    onClick={() => setSelectedSubSubject(sub)}
                  >
                    <span className="subject-name">{sub.subject}</span>
                    <span className="subject-doc-count">{sub.notes.length}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Main Content Area - Documents */}
            <div className="documents-main-area">
              {selectedSubSubject && (
                <>
                  <div className="documents-header">
                    <h2>{selectedSubSubject.subject}</h2>
                    <span className="total-docs-badge">
                      {selectedSubSubject.notes.length} Documents
                    </span>
                  </div>

                  <div className="documents-list">
                    {selectedSubSubject.notes.map((doc, index) => (
                      <div key={index} className="document-item">
                        <div className="doc-info">
                          <span className="doc-sr">#{index + 1}</span>
                          <div className="doc-details">
                            <span className="doc-title">{doc.title}</span>
                            <span className="doc-type">PDF Document</span>
                          </div>
                        </div>
                        <button
                          className="view-doc-btn"
                          onClick={() => window.open(doc.link, "_blank")}
                        >
                          View
                        </button>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <style jsx>{`
          .econtent-container {
            padding: 2rem;
            max-width: 1400px;
            margin: 0 auto;
          }

          .main-title {
            text-align: center;
            color: #333;
            font-size: 2.5rem;
            margin-bottom: 3rem;
            font-weight: 600;
          }

          /* Main Subjects Grid - 4 in a row */
          .subjects-main-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 2rem;
            padding: 1rem;
          }

          .main-subject-card {
            background: #0b0b53;
            color: white;
            padding: 2.5rem 1.5rem;
            border-radius: 1.5rem;
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
            min-height: 280px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
          }

          .main-subject-card:hover {
            transform: translateY(-10px) scale(1.02);
            box-shadow: 0 20px 40px rgba(102, 126, 234, 0.5);
          }

          .subject-icon {
            font-size: 5rem;
            margin-bottom: 1.5rem;
          }

          .main-subject-card h2 {
            margin: 0 0 1rem 0;
            font-size: 2rem;
            font-weight: 600;
          }

          .subject-count {
            margin: 0 0 1.5rem 0;
            opacity: 0.9;
            font-size: 1.1rem;
          }

          .explore-btn {
            padding: 0.8rem 2rem;
            background: rgba(255, 255, 255, 0.2);
            color: white;
            border: 2px solid white;
            border-radius: 2rem;
            font-size: 1rem;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .explore-btn:hover {
            background: white;
            color: #667eea;
          }

          /* Detail View Layout */
          .detail-layout {
            display: grid;
            grid-template-columns: 350px 1fr;
            gap: 2rem;
            margin-top: 1rem;
            min-height: 600px;
          }

          .mobile-back-btn {
            display: none;
            padding: 1rem;
            background: #f0f0f0;
            border: none;
            border-radius: 0.5rem;
            font-size: 1rem;
            cursor: pointer;
            margin-bottom: 1rem;
          }

          /* Sidebar Styles */
          .subjects-sidebar {
            background: white;
            border-radius: 1rem;
            box-shadow: 0 4px 20px rgba(0,0,0,0.1);
            overflow: hidden;
            height: fit-content;
            position: sticky;
            top: 1rem;
          }

          .sidebar-header {
            padding: 2rem;
            background: #0b0b53;
            color: white;
          }

          .back-btn {
            padding: 0.5rem 1rem;
            background: rgba(255, 255, 255, 0.2);
            color: white;
            border: 1px solid white;
            border-radius: 0.5rem;
            cursor: pointer;
            margin-bottom: 1rem;
            font-size: 0.9rem;
          }

          .back-btn:hover {
            background: rgba(255, 255, 255, 0.3);
          }

          .sidebar-header h3 {
            margin: 0.5rem 0;
            font-size: 1.8rem;
            font-weight: 600;
          }

          .total-topics {
            margin: 0;
            opacity: 0.9;
            font-size: 1rem;
          }

          .sidebar-subjects-list {
            padding: 1.5rem;
          }

          .sidebar-subject-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1.2rem;
            margin-bottom: 0.8rem;
            border-radius: 0.8rem;
            cursor: pointer;
            transition: all 0.2s ease;
            background: #f8f9fa;
            border: 2px solid transparent;
          }

          .sidebar-subject-item:hover {
            background: #e2e8f0;
            transform: translateX(5px);
          }

          .sidebar-subject-item.active {
            background: #0b0b53;
            color: white;
            border-color: #764ba2;
          }

          .sidebar-subject-item.active .subject-doc-count {
            background: white;
            color: #667eea;
          }

          .subject-name {
            font-weight: 600;
            font-size: 1.1rem;
          }

          .subject-doc-count {
            background: #e0e0e0;
            padding: 0.3rem 0.8rem;
            border-radius: 2rem;
            font-size: 0.9rem;
            font-weight: 600;
          }

          /* Documents Main Area */
          .documents-main-area {
            background: white;
            border-radius: 1rem;
            box-shadow: 0 4px 20px rgba(0,0,0,0.1);
            padding: 2rem;
          }

          .documents-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            padding-bottom: 1rem;
            border-bottom: 2px solid #e0e0e0;
          }

          .documents-header h2 {
            margin: 0;
            font-size: 2rem;
            color: #333;
          }

          .total-docs-badge {
            background: #48bb78;
            color: white;
            padding: 0.6rem 1.2rem;
            border-radius: 2rem;
            font-size: 1rem;
            font-weight: 500;
          }

          .documents-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .document-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1.2rem 1.5rem;
            background: #f8f9fa;
            border-radius: 1rem;
            transition: all 0.2s ease;
            border: 1px solid #e0e0e0;
          }

          .document-item:hover {
            transform: translateX(5px);
            border-color: #0b0b53;
            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1);
          }

          .doc-info {
            display: flex;
            align-items: center;
            gap: 1.5rem;
          }

          .doc-sr {
            background: #0b0b53;
            color: white;
            width: 3rem;
            height: 3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            font-weight: 600;
            font-size: 1rem;
          }

          .doc-details {
            display: flex;
            flex-direction: column;
            gap: 0.3rem;
          }

          .doc-title {
            font-size: 1.2rem;
            color: #333;
            font-weight: 600;
          }

          .doc-type {
            font-size: 0.9rem;
            color: #666;
          }

          .view-doc-btn {
            padding: 0.8rem 2rem;
            background: #48bb78;
            color: white;
            border: none;
            border-radius: 0.8rem;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 1rem;
            font-weight: 500;
            width:200px
          }

          .view-doc-btn:hover {
            background: #38a169;
            transform: scale(1.05);
          }

          /* Responsive Design */
          @media (max-width: 1200px) {
            .subjects-main-grid {
              grid-template-columns: repeat(3, 1fr);
            }
          }

          @media (max-width: 900px) {
            .subjects-main-grid {
              grid-template-columns: repeat(2, 1fr);
            }
            
            .detail-layout {
              grid-template-columns: 1fr;
            }
            
            .subjects-sidebar {
              position: static;
            }

            .mobile-back-btn {
              display: block;
            }
          }

          @media (max-width: 600px) {
            .econtent-container {
              padding: 1rem;
            }

            .subjects-main-grid {
              grid-template-columns: 1fr;
            }

            .main-subject-card {
              min-height: 220px;
            }

            .doc-info {
              flex-direction: column;
              align-items: flex-start;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default E_Content;